import React, { useMemo } from "react";
import { orderWith } from "@insightfulscience/shared-utils/fn";
import { select, compareBy } from "@insightfulscience/shared-utils/fn/comparators";
import { usePageData } from "@insightfulscience/smart-react/hocs/DiPageHoC";

/**
 * undefined -> null
 * [] -> null
 * [{}] -> not null
 */
const nullIfListEmpty = list => (Array.isArray(list) && list.length > 0 ? list : null);

const sortCountries = orderWith(
	select(({ id }) => +id === 220), // USA first,
	select(({ id }) => +id === 241), // Afghanistan,
	select(({ id }) => +id === 248), // Åland Islands
	compareBy(({ name }) => name.toLowerCase()), // Case insensetive alpha order
);

export function useCountries() {
	const { countries, taxCountries } = usePageData();

	const byId = useMemo(
		() => new Map(countries.map(country => [+country.id, country])), // factory
		[countries], // deps
	);

	const list = React.useMemo(
		() => sortCountries(countries),
		[countries], //
	);

	return [list, byId, taxCountries];
}

export function useCountryData(countryID) {
	const { countries } = usePageData();
	const country = React.useMemo(
		() => countries?.find(({ id }) => +id === +countryID),
		[countryID, countries], //
	);
	return country;
}

export function useCountryStates(countryID) {
	const country = useCountryData(countryID);
	return nullIfListEmpty(country?.states);
}
